 
import $ from 'jquery';
import ko from 'knockout';
import {getFormData} from './emailsignupdata';
import {isDynamicFormValid} from '../../validation/unobtrusivehelpers';
import {HTTP_STATUS_OK, HTTP_STATUS_NOCONTENT} from '../../smartpak/httpstatus';
import EmailOptionsViewModel from './viewmodels/emailoptionsviewmodel';
import modal from '../../smartpak/modal';

getFormData().then(response => {
    if (response.status === HTTP_STATUS_OK) {
        const $form = document.getElementById('email-options-form'),
            emailOptionsViewModel = new EmailOptionsViewModel(response.content);

        if ($form) {
            ko.applyBindings(emailOptionsViewModel, $form);

            const $button = $form.querySelector('.button.primary');

            if ($button) {
                $button.addEventListener('click', e => {
                    e.preventDefault();
                    handleSubmit($form, emailOptionsViewModel);
                });
            }
        }
    }

    function handleSubmit($form, emailOptionsViewModel) {
        const $container = document.getElementById('email-options'),
            $success = document.getElementById('email-options-success');
    
        if (isDynamicFormValid($($form))) {
            emailOptionsViewModel.save()
                .then(response => {
                    if ($container && $success && response.Status === HTTP_STATUS_NOCONTENT) {
                        $container.classList.add('jsHide');
                        $success.classList.remove('jsHide');
                    }else{
                        showFailedRequestModal(response.Content);
                    }
                })
                .catch(() => showFailedRequestModal());
        }
    }
});

function showFailedRequestModal(errorMessage){
    const $div = document.createElement('div');
    
    $div.innerHTML = errorMessage || 'Something went wrong, please try again';
    modal($div, {
        title: 'Error',
        removeContents: true
    });
}